import React, { useState } from 'react'
import Radium from 'proofpoint-radium'
import ReactHTMLParser from 'react-html-parser'
import _ from 'lodash'

const Span = ({
  id,
  style,
  content,
  className,
  selectedLanguageShortname,
  updateMainContainerState,
  item,
  mode,
  onChangeSectionEditorState, // from section editor
  selectedEditableComponent // from section editor
}) => {
  const [ contentEditable, updateContentEditable ] = useState( false )
  return (
    <span
      id={ id }
      style={{
        ...style,
        outline: selectedEditableComponent ? selectedEditableComponent.id === id ? '2px solid #007bff' : 'none' : 'none'
      }}
      className={ className }
      onClick={
        mode === 'edit' ? ( e ) => {
          onChangeSectionEditorState( 'selectedEditableComponent', item )
        } : () => {}
      }>
      { !_.isEmpty(content) && content[ selectedLanguageShortname ] ? ReactHTMLParser( content[ selectedLanguageShortname ] ) : ReactHTMLParser( content[ 'en' ] ) }
    </span>
  )
}

export default Radium( Span )